import { DICT_KEY, getDictNameByCode, getModel, setModel } from "../../../utils/constants";
import ModelUtils from "../../../utils/ModelUtils";
import partDealService from "./partDealService";
import moment from "moment";
// import {v4 as uuidv4} from "uuid"

const partDealModel = {
    state: {
        //查询参数
        searchParam: {},
        //配件交易频次查询列表
        partDealList: [],
        //配件交易频次->选中keys
        partDealListSelectedRowKeys: [],
        //配件交易频次分页
        searcnPage: {
            total: 0,
            pageNum: 1,
            pageSize: 15
        }
    },

    reducers: {
        setSearchParam(state, payload) {
            state.searchParam = { ...state.searchParam, ...payload };
            // if (cacheAble) setModel(MODEL_KEY, {...state});
        },
        resetSearchParam(state,) {
            state.searchParam = {};
            // if (cacheAble) setModel(MODEL_KEY, {...state});
        },
        setPartDealListSelectedRowKeys(state, payload) {
            state.partDealListSelectedRowKeys = payload;
            // setModel(MODEL_KEY, {...state});
        },
        setPartDealListList(state, payload){
            state.partDealList = payload;
        },
        setSearcnPage(state, payload) {
            state.searcnPage = payload;
            // if (cacheAble) setModel(MODEL_KEY, {...state});
        },
    },

    effects: () => ({
        //加载配件交易列表
        async loadListDetail({ showMsg = true, duration = 5, data }) {
            const funName = "加载配件交易数据";
            const sucMsg = funName + "成功!";
            const failMsg = funName + "失败!";
            // console.log("加载成功", data)
            data.customerName = getDictNameByCode(DICT_KEY.CM_DICT.CUSTOMER, data.customerName)
            const func = async () => {
                let retData = await partDealService.findPage(data);
                const {list, ...page} = retData;
                const mappedList = list.map(el => {
                    return {
                        key: el.id,
                        ...el,
                        orgName: el.orgId ? getDictNameByCode(DICT_KEY.CM_DICT.ORG, el.orgId, true) : "",
                        engineTypeName: el.engineType ? getDictNameByCode(DICT_KEY.CM_DICT.ENGINE_TYPE, el.engineType) : "",
                        warehouseName: el.warehouseId ? getDictNameByCode(DICT_KEY.CM_DICT.WAREHOUSE, el.warehouseId) : "",
                        orderStatusName: el.orderStatus ? getDictNameByCode(DICT_KEY.CM_DICT.STOCK_CHECK_STATUS, el.orderStatus) : "",
                    }
                })
                // list.forEach(el => el.key = el.id);
                this.setPartDealListList(mappedList);
                this.setSearcnPage(page);
            };
            return await ModelUtils.execute({
                funName, sucMsg, failMsg, showMsg, duration
            }, func);

        },
        //导出配件交易列表
        async exportPartDealList({ showMsg = true, duration = 5, data }) {
            const funName = "导出盘点数据";
            const sucMsg = funName + "成功!";
            const failMsg = funName + "失败!";
            // console.log("导出成功")
            const func = async () => {
                let retData = await partDealService.export(data);
                return retData;
            };
            return await ModelUtils.execute({
                funName, sucMsg, failMsg, showMsg, duration
            }, func);
        },
    })
};

export default partDealModel;